// Fixed brand color palette for product color selection.
// Source: "Michel Bandali Design — Colour Palette" reference image.
// Hex values are eyeballed from that image; adjust here if exact brand
// hex codes become available — every consumer reads from this one list.
export const COLOR_PALETTE = [
  { name: "White", hex: "#FFFFFF" },
  { name: "Peach Blush", hex: "#F2A783" },
  { name: "Dusty Rose", hex: "#C67B72" },
  { name: "Blush Pink", hex: "#F5A0D0" },
  { name: "Blood Red", hex: "#C41230" },
  { name: "Burgundy Red", hex: "#9E1C24" },
  { name: "Fuchsia", hex: "#D0127A" },
  { name: "Golden Ochre", hex: "#F0930C" },
  { name: "Lemon Lime", hex: "#F5D808" },
  { name: "Olive Green", hex: "#9CAC1E" },
  { name: "Moss Green", hex: "#66741C" },
  { name: "Deep Teal", hex: "#0F6C6E" },
  { name: "Petrol Blue", hex: "#124F76" },
  { name: "Lagoon Blue", hex: "#1FA8D6" },
  { name: "Mediterranean Blue", hex: "#1179C4" },
  { name: "Sky Blue", hex: "#82C6EC" },
  { name: "Periwinkle Blue", hex: "#7488E0" },
  { name: "Cobalt Blue", hex: "#1554E6" },
  { name: "Midnight Navy", hex: "#0F3468" },
];

const PALETTE_BY_LOWER_NAME = new Map(
  COLOR_PALETTE.map((c) => [c.name.toLowerCase(), c])
);

/** Look up a palette entry by name, case-insensitively. */
export function findPaletteColor(name) {
  if (!name) return null;
  return PALETTE_BY_LOWER_NAME.get(String(name).trim().toLowerCase()) || null;
}

/**
 * Resolve a stored color value (palette name OR legacy free-text value)
 * to something usable as a CSS `background-color`.
 * - Matches a palette name -> that swatch's hex.
 * - Otherwise returns the raw value as-is, so legacy values that already
 *   happen to be valid CSS colors (e.g. "Blue", "Turquoise") keep working.
 *   Values that aren't valid CSS colors simply render as no background,
 *   same as before this palette existed — never a regression.
 */
export function resolveColorHex(rawValue) {
  const match = findPaletteColor(rawValue);
  return match ? match.hex : rawValue;
}

/** Is this stored value one of our fixed palette colors? */
export function isPaletteColor(rawValue) {
  return !!findPaletteColor(rawValue);
}
